// generated with "print-required-polyfills.ts" script (based on core-js-compat and browserslistrc)
import 'core-js/modules/es.symbol.dispose';
import 'core-js/modules/es.error.is-error';
import 'core-js/modules/es.suppressed-error.constructor';
import 'core-js/modules/es.array.includes';
import 'core-js/modules/es.array.push';
import 'core-js/modules/es.array.to-reversed';
import 'core-js/modules/es.array.to-sorted';
import 'core-js/modules/es.array.to-spliced';
import 'core-js/modules/es.array.with';
import 'core-js/modules/es.data-view.get-float16';
import 'core-js/modules/es.data-view.set-float16';
import 'core-js/modules/es.array-buffer.detached';
import 'core-js/modules/es.array-buffer.transfer';
import 'core-js/modules/es.array-buffer.transfer-to-fixed-length';
import 'core-js/modules/es.disposable-stack.constructor';
import 'core-js/modules/es.iterator.constructor';
import 'core-js/modules/es.iterator.concat';
import 'core-js/modules/es.iterator.dispose';
import 'core-js/modules/es.iterator.drop';
import 'core-js/modules/es.iterator.every';
import 'core-js/modules/es.iterator.filter';
import 'core-js/modules/es.iterator.find';
import 'core-js/modules/es.iterator.flat-map';
import 'core-js/modules/es.iterator.for-each';
import 'core-js/modules/es.iterator.from';
import 'core-js/modules/es.iterator.map';
import 'core-js/modules/es.iterator.reduce';
import 'core-js/modules/es.iterator.some';
import 'core-js/modules/es.iterator.take';
import 'core-js/modules/es.iterator.to-array';
import 'core-js/modules/es.json.is-raw-json';
import 'core-js/modules/es.json.parse';
import 'core-js/modules/es.json.raw-json';
import 'core-js/modules/es.json.stringify';
import 'core-js/modules/es.map.group-by';
import 'core-js/modules/es.map.get-or-insert';
import 'core-js/modules/es.map.get-or-insert-computed';
import 'core-js/modules/es.math.f16round';
import 'core-js/modules/es.math.sum-precise';
import 'core-js/modules/es.object.group-by';
import 'core-js/modules/es.promise.try';
import 'core-js/modules/es.promise.with-resolvers';
import 'core-js/modules/es.array.from-async';
import 'core-js/modules/es.async-disposable-stack.constructor';
import 'core-js/modules/es.async-iterator.async-dispose';
import 'core-js/modules/es.regexp.escape';
import 'core-js/modules/es.set.difference.v2';
import 'core-js/modules/es.set.intersection.v2';
import 'core-js/modules/es.set.is-disjoint-from.v2';
import 'core-js/modules/es.set.is-subset-of.v2';
import 'core-js/modules/es.set.is-superset-of.v2';
import 'core-js/modules/es.set.symmetric-difference.v2';
import 'core-js/modules/es.set.union.v2';
import 'core-js/modules/es.string.is-well-formed';
import 'core-js/modules/es.string.to-well-formed';
import 'core-js/modules/es.typed-array.to-reversed';
import 'core-js/modules/es.typed-array.to-sorted';
import 'core-js/modules/es.typed-array.with';
import 'core-js/modules/es.weak-map.get-or-insert';
import 'core-js/modules/es.weak-map.get-or-insert-computed';
import 'core-js/modules/es.uint8-array.from-base64';
import 'core-js/modules/es.uint8-array.from-hex';
import 'core-js/modules/es.uint8-array.set-from-base64';
import 'core-js/modules/es.uint8-array.set-from-hex';
import 'core-js/modules/es.uint8-array.to-base64';
import 'core-js/modules/es.uint8-array.to-hex';
import 'core-js/modules/esnext.array.group';
import 'core-js/modules/esnext.array.group-by';
import 'core-js/modules/esnext.array.group-by-to-map';
import 'core-js/modules/esnext.array.group-to-map';
import 'core-js/modules/esnext.async-iterator.constructor';
import 'core-js/modules/esnext.async-iterator.drop';
import 'core-js/modules/esnext.async-iterator.every';
import 'core-js/modules/esnext.async-iterator.filter';
import 'core-js/modules/esnext.async-iterator.find';
import 'core-js/modules/esnext.async-iterator.flat-map';
import 'core-js/modules/esnext.async-iterator.for-each';
import 'core-js/modules/esnext.async-iterator.from';
import 'core-js/modules/esnext.async-iterator.map';
import 'core-js/modules/esnext.async-iterator.reduce';
import 'core-js/modules/esnext.async-iterator.some';
import 'core-js/modules/esnext.async-iterator.take';
import 'core-js/modules/esnext.async-iterator.to-array';
import 'core-js/modules/esnext.function.metadata';
import 'core-js/modules/esnext.iterator.to-async';
import 'core-js/modules/esnext.iterator.zip';
import 'core-js/modules/esnext.iterator.zip-keyed';
import 'core-js/modules/esnext.symbol.metadata';
import 'core-js/modules/esnext.typed-array.to-spliced';
import 'core-js/modules/web.dom-exception.stack';
import 'core-js/modules/web.immediate';
import 'core-js/modules/web.structured-clone';
import 'core-js/modules/web.url.can-parse';
import 'core-js/modules/web.url.parse';
import 'core-js/modules/web.url-search-params.delete';
import 'core-js/modules/web.url-search-params.has';
import 'core-js/modules/web.url-search-params.size';

// the datepicker still requires zone.js, maybe other things too
import 'zone.js';
